export default __webpack_public_path__ + "static/media/slider.223616ac.svg";